import { useMemo } from 'react';
import { FILTER_NAMES } from '../../../../../components/filters/hooks/filter-names.constants';
import { FilterSelectedValue } from '../../../../../hooks/filters/interfaces/filter-selected-value.interface';
const isLevelEnabled = (selectedValue?: FilterSelectedValue) => {
  return selectedValue && selectedValue.values.length === 1;
};
export const useProdHierFilterSelection = (
  filterSel: FilterSelectedValue[],
) => {
  const filterSelection = useMemo(() => {
    const categoryValue = filterSel.find((i) => i.id === FILTER_NAMES.CATEGORY);
    const brandValue = filterSel.find((i) => i.id === FILTER_NAMES.BRAND);
    const subBrandValue = filterSel.find((i) => i.id === FILTER_NAMES.SUBBRAND);
    const sizeGroupValue = filterSel.find(
      (i) => i.id === FILTER_NAMES.SIZEGROUP,
    );
    const prodHierValue: FilterSelectedValue = {
      id: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
      values: [],
    };
    if (!isLevelEnabled(categoryValue)) {
      //console.log('categoryValue', categoryValue)
      prodHierValue.values.push({
        value: FILTER_NAMES.CATEGORY,
        label: '',
      });
    }
    if (!isLevelEnabled(brandValue)) {
      prodHierValue.values.push({
        value: FILTER_NAMES.BRAND,
        label: '',
      });
    }
    if (!isLevelEnabled(subBrandValue)) {
      prodHierValue.values.push({
        value: FILTER_NAMES.SUBBRAND,
        label: '',
      });
    }
    if (!isLevelEnabled(sizeGroupValue)) {
      prodHierValue.values.push({
        value: FILTER_NAMES.SIZEGROUP,
        label: '',
      });
    }
    prodHierValue.values.push({
      value: FILTER_NAMES.PPG,
      label: '',
    });
    const ret = filterSel.filter(
      (i) => i.id !== FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    );
    ret.push(prodHierValue);
    return ret;
  }, [filterSel]);
  return filterSelection;
};
